<template>
  <div v-loading="loading">
    <h3>Sensor List</h3>
    <SimpleTable :headers="getHeaders()" :items="items" tableId="DceId" />
  </div>
</template>

<script>
import SimpleTable from '@/components/dx/SimpleTable'

export default {
  components: {
    SimpleTable
  },
  props: {
    formula: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      items: [],
      loading: false
    }
  },
  mounted() {
    this.fetchDataById()
  },
  methods: {
    getHeaders() {
      return [
        {
          type: 'string',
          value: 'Name'
        }
      ]
    },
    async fetchDataById() {
      try {
        this.loading = true
        const res = await this.$axios.get(
          this.$appInfo.api.formula.getAllComponent + `?id=${this.formula.Id}`
        )

        this.items = res.data[0].ListSensor.map(function (item) {
          item.Id = item.DeviceDceId
          return item
        })

        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    }
  }
}
</script>
